export default "__VITE_ASSET__ed5542af__"